import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useLocation, useNavigate } from "react-router-dom"
import { ROUTES } from "@/helpers/routes"
import { useHasSession } from "@/hooks/useHasSession"
import { useModals } from "@/modals/hooks"
import { useAppSelector } from "@/store"
import { PlayerSelectors } from "@/store/slices/player"
import styles from "./NavigationHud.module.scss"
import { NAV_ITEMS } from "./config"
import { deriveActiveNavTab, NavTab } from "./helpers"
import { INavigationHudProps } from "./types"
import { NavButton } from "./ui/NavButton"

export const NavigationHud: FC<INavigationHudProps> = ({ encumbrance }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { modals, openModal, closeModal, closeAllModals } = useModals()

  const isPlayerLoaded = useAppSelector(PlayerSelectors.selectIsPlayerLoaded())
  const hasSession = useHasSession()

  if (!hasSession || !isPlayerLoaded) {
    return null
  }

  const active = deriveActiveNavTab(location.pathname, modals)

  const handleClick = (tab: NavTab) => {
    if (tab === "map") {
      closeAllModals()
      navigate(ROUTES.HOME)
      return
    }
    if (tab === "inventory") {
      if (modals["hero"]) {
        closeModal("hero")
      }
      if (!modals["inventory"]) {
        openModal("inventory")
      }
      return
    }
    if (tab === "hero") {
      if (modals["inventory"]) {
        closeModal("inventory")
      }
      if (modals["inventoryItem"]) {
        closeModal("inventoryItem")
      }
      if (modals["inventoryDiscardConfirm"]) {
        closeModal("inventoryDiscardConfirm")
      }
      if (!modals["hero"]) {
        openModal("hero")
      }
      return
    }
    // clan — no screen yet
  }

  return (
    <nav className={styles.NavigationHud}>
      {NAV_ITEMS.map((item) => (
        <NavButton
          key={item.tab}
          icon={item.icon}
          label={t(item.labelKey)}
          active={active === item.tab}
          onClick={() => handleClick(item.tab)}
          encumbrance={item.tab === "inventory" ? encumbrance : undefined}
        />
      ))}
    </nav>
  )
}
